export class TaskCost {
  id: number;
  appropriatevalue: number;
  plannedvalue: number;
  balancevalue: number;
  percentage: number;
}
